export type OrgStatusBucket =
  | 'active'
  | 'trial'
  | 'past_due'
  | 'blocked'
  | 'canceled'
  | 'other';

export function resolveOrgStatusBucket(input: {
  subscriptionStatus: string | null;
  blockedAt: string | null;
  trialEndsAt: string | null;
  now?: Date;
}): OrgStatusBucket {
  const now = input.now ?? new Date();

  if (input.blockedAt) {
    const blockedAt = new Date(input.blockedAt);
    if (!Number.isNaN(blockedAt.getTime()) && blockedAt <= now) {
      return 'blocked';
    }
  }

  const status = input.subscriptionStatus?.toLowerCase() ?? null;

  if (status === 'canceled' || status === 'cancelled') {
    return 'canceled';
  }

  if (status === 'blocked') {
    return 'blocked';
  }

  if (status === 'past_due') {
    return 'past_due';
  }

  if (status === 'trialing') {
    if (input.trialEndsAt) {
      const trialEndsAt = new Date(input.trialEndsAt);
      if (!Number.isNaN(trialEndsAt.getTime()) && trialEndsAt > now) {
        return 'trial';
      }
    }
  }

  if (status === 'active') {
    return 'active';
  }

  return 'other';
}

const LABELS: Record<OrgStatusBucket, string> = {
  active: 'Ativo',
  trial: 'Trial',
  past_due: 'Inadimplente',
  blocked: 'Bloqueado',
  canceled: 'Cancelado',
  other: '—',
};

export function orgStatusLabel(bucket: OrgStatusBucket): string {
  return LABELS[bucket];
}
